import { Grid, Box } from '@mui/material'
import { Card, CardHeader, TextFieldC } from 'components'
import { cellPhoneMask, Yup } from 'utils'

export const ContactSchema = Yup.object({
  contact: Yup.string().max(40),
  phone: Yup.string().max(20),
  email: Yup.string().email().max(60)
})

export type ContactType = {
  contact: string
  phone: string
  email: string
}

export const contactDefaultValues = {
  contact: '',
  phone: '',
  email: ''
}

export const ContactForm = () => {
  return (
    <Box>
      <Card
        sx={{
          visibility: { xs: 'hidden', sm: 'visible', md: 'visible' },
          padding: { xs: 0, sm: '24px', md: '24px' },
          maxWidth: 850
        }}
      >
        <Box
          sx={{
            visibility: { xs: 'visible', sm: 'visible', md: 'visible' }
          }}
        >
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              visibility: 'visible'
            }}
          >
            <CardHeader title="Contato" />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextFieldC name="contact.contact" label="Nome" />
              </Grid>
              <Grid item xs={12}>
                <TextFieldC
                  name="contact.phone"
                  label="Telefone"
                  normalize={(value) => cellPhoneMask(value)}
                  placeholder="(00) 0 0000-0000"
                />
              </Grid>
              <Grid item xs={12}>
                <TextFieldC
                  name="contact.email"
                  label="E-mail"
                  normalize={(value) => value.toLowerCase()}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Card>
    </Box>
  )
}
